import VGridformModule from './state/store'
import VGridformBaseModule from './state/base'
import VGridform from './components/v-gridform'
import VGridformField from './components/v-gridform-field'
import VGridformBuilder from './components/v-gridform-builder'
import { VERSION, CONST } from './shared/constants'
import dialog from './shared/dialog'

// This is your plugin object. It can be exported to be used anywhere.
const VueGridform = {
    // The "install" method is all that needs to exist on the plugin object.
    // It takes the global Vue object as well as user-defined options.
    install(Vue, options = {}) {
        Vue.component(VGridform.name, VGridform)
        Vue.component(VGridformField.name, VGridformField)
        Vue.component(VGridformBuilder.name, VGridformBuilder)

        // Object containing Gridform objects
        const $gridform = { dialog }

        const { store } = options
        if (store) {
            // global options for all forms
            store.registerModule(CONST.NAMESPACE, VGridformModule)

            // register nested gridform module for every instance
            $gridform.registerNestedModule = function(nested) {
                if (!nested) return

                // TODO ensure unique nested names
                //  maybe create a uuid and map this internal?
                store.registerModule(
                    [CONST.NAMESPACE, '_' + nested],
                    VGridformBaseModule
                )
            }
        }

        Vue.prototype.$gridform = $gridform

        const isReady = {}
        const gfHandler = {}
        Vue.prototype.$gridform.ready = (name, fn) => {
            if (!name) return
            if (isReady[name]) {
                fn($gridform[name])
                return
            }

            // add ready listener
            gfHandler[name] = gfHandler[name] || []
            gfHandler[name].push(fn)
        }
        Vue.prototype.$gridform.trigger = (name, type) => {
            if (!name) return

            if (type === 'ready') isReady[name] = true
            if (gfHandler[name]) {
                gfHandler[name].forEach(fn => {
                    fn($gridform[name])
                })
            }
        }
        Vue.prototype.$gridform.destroy = (name) => {
            if (!name || !$gridform[name]) return

            isReady[name] = false
            gfHandler[name] = null
            $gridform[name] = null
            delete $gridform[name]
        }

        // DEV expose to global namespace for tests
        if (process.env.NODE_ENV === 'development') window.$gridform = $gridform
    },
    version: VERSION
}

export default VueGridform

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(VueGridform)
}
